<template>
  <div class="page-header">
    <div class="header-top">
      <div class="main">
        <div class="header-top-wrapper">
          <div class="tit" tabindex="0">河南省交通事业发展中心，欢迎您！</div>
          <div class="header-time" tabindex="0">{{ currentDate }}</div>
        </div>
      </div>
    </div>
    <div
      class="header-center"
      :style="{
        'background-image': `url(${banner})`,
      }"
    >
      <div class="main header-logo">
        <!-- <img :src="Logo" class="img" alt="" /> -->
        <img
          src="images/index/logo.png"
          style="opacity: 0"
          class="img"
          @click="toHome()"
          tabindex="0"
        />
        <div class="header-search">
          <div class="header-search__changeMode" v-if="false">
            <div
              class="btn accessible"
              title="无障碍阅读"
              @click="set_AccessibleMode(true)"
              tabindex="0"
            >
              无障碍阅读
            </div>
            <div
              class="btn oldman"
              title="进入适老模式"
              @click="setOldMan"
              tabindex="0"
            >
              进入适老模式
            </div>
          </div>
          <div class="header-search__search">
            <el-input
              placeholder="请输入查询内容"
              v-model.trim="keywords"
              class="el-input-search"
              @keyup.enter.native="changeKeywords()"
              tabindex="0"
            >
            </el-input>
            <div
              class="header-search__btn"
              @click="changeKeywords()"
              tabindex="0"
            >
              搜 索
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-nav" id="headerNav">
      <div class="main">
        <ul class="header-nav-wrapper">
          <!-- <li class="nav-item">
            <router-link to="/index" class="nav-item-a">
              <span class="title" data-name="index"> 首页 </span>
            </router-link>
          </li> -->
          <li
            v-for="(item, i) in list"
            :key="i"
            class="nav-item"
            @click="clickNavItem(item)"
          >
            <a
              :href="item.meta.link"
              target="_blank"
              class="nav-item-a"
              v-if="item.meta.link"
            >
              <span class="title" :data-name="item.name">
                {{ item.meta.title }}
              </span>
            </a>
            <router-link v-else :to="item.path" class="nav-item-a">
              <span class="title" :data-name="item.name">
                {{ item.meta.title }}
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { routesNav } from "@/router/index";
export default {
  name: "IndexHeader",
  components: {},
  data() {
    return {
      keywords: "",
      // oldMan: false,
      // Logo: require("public/images/index/logo.png"),
      // currentDate: new Date(),
    };
  },
  computed: {
    ...mapState({
      oldManMode(state) {
        return state.oldManMode;
      },
      banner: (state) => {
        return `${process.env.VUE_APP_BASE_API_IMAGE}${state.websitInfo.banner}`;
      },
    }),
    currentDate() {
      const date = new Date();
      const y = date.getFullYear();
      const mm = date.getMonth() + 1;
      const dd = date.getDate();
      const w = date.getDay();
      let week = "星期";
      switch (w) {
        case 0:
          week += "日";
          break;
        case 1:
          week += "一";
          break;
        case 2:
          week += "二";
          break;
        case 3:
          week += "三";
          break;
        case 4:
          week += "四";
          break;
        case 5:
          week += "五";
          break;
        case 6:
          week += "六";
          break;
        default:
          week = "";
          break;
      }
      return `${y}年${mm}月${dd}日 ${week}`;
    },
    list() {
      return routesNav.filter((v) => !v.meta.hidden);
    },
  },
  mounted() {
    // const navItems = document.querySelectorAll("#headerNav .nav-item-a .title");
    // navItems.forEach((v) => {
    //   v.addEventListener("mouseover", this.navItemMouseover);
    // });
  },
  beforeDestroy() {
    // const navItems = document.querySelectorAll("#headerNav .nav-item-a .title");
    // navItems.forEach((v) => {
    //   v.removeEventListener("mouseover", this.navItemMouseover);
    // });
  },
  methods: {
    ...mapMutations(["set_oldManMode", "set_AccessibleMode"]),
    setOldMan() {
      // const oldManMode = this.oldManMode;
      // this.set_oldManMode(oldManMode);
      this.set_oldManMode();
    },
    changeKeywords() {
      if (!this.keywords) return;
      this.$router.push({
        name: "search_result",
        query: { keywords: this.keywords },
      });
    },
    navItemMouseover(e) {
      if (sessionStorage.getItem("isRouteIndex") === "1") {
        const currentRouteName = e.currentTarget.dataset.name;
        // // 1. hover
        // this.currentRouteName = currentRouteName;
        // 2. router.push
        if (currentRouteName !== "traffic") {
          this.$router.push({ name: currentRouteName });
        }
      }
    },

    clickNavItem() {
      sessionStorage.setItem("isRouteIndex", "");
    },
    toHome() {
      this.$router.push("/index");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-center {
  background: no-repeat center/cover;
  .header-logo {
    // height: 273px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
}
.header-search {
  position: relative;
  .header-search__changeMode {
    display: flex;
    margin-bottom: 16px;
    justify-content: flex-end;
    user-select: none;
    .btn {
      // height: 38px;
      // line-height: 38px;
      display: block;
      float: right;
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      font-size: 16px;
      font-size: var(--font-size-16);
      letter-spacing: 0.32px;

      &.oldman {
        background: #f79600;
        color: #fff;
        border: 1px solid #f79600;
        border-radius: 0px 2px 2px 0px;
      }
      &.accessible {
        background: #fff;
        color: #f76b00;
        border: 1px solid #fc740d;
        border-radius: 2px 0px 0px 2px;
      }
    }
  }
}
.header-search__search {
  display: flex;
  ::v-deep .el-input {
    overflow: hidden;
    width: 285px;
    height: 40px;
    // background: rgba(255, 255, 255, 0.39);
    // border: 1px solid #e4e7ed;
    border-radius: 5px 0px 0px 5px;
    font-size: 14px;
    font-size: var(--font-size-14);
    .el-input__inner {
      border-radius: 0;
    }
  }
  .header-search__btn {
    text-align: center;
    width: 76px;
    height: 40px;
    line-height: 40px;
    background: #0d7ce4;
    border-radius: 0px 5px 5px 0px;

    font-size: 14px;
    font-size: var(--font-size-14);
    font-weight: bold;
    color: #ffffff;
  }
}

.header-time {
  margin-left: auto;
  padding-right: 14px;
  font-size: 14px;
  font-size: var(--font-size-14);
  font-weight: 400;
  line-height: 20px;
  color: #303133;
}
.page-header {
  font-size: 0;
  // background-color: #0d7ce4;
  position: relative;
  min-width: 1400px;
}
.header-top {
  background-color: #fff;

  position: relative;

  .main {
  }
  .header-top-wrapper {
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tit {
    font-size: 14px;
    font-size: var(--font-size-14);
    font-weight: 400;
    line-height: 20px;
    color: #303133;
  }
}
.header-nav {
  // font-size: 0;
  background-color: #0d7ce4;
  position: relative;
  .main {
    display: flex;
    justify-content: flex-end;
    position: relative;
  }
  .header-nav-wrapper {
    display: flex;
    width: 100%;
  }
  .nav-item {
    //   display: inline-block;
    font-size: 16px;
    font-size: var(--font-size-16);
    height: 55px;
    line-height: 55px;
    //   width: 92px;
    flex: 1;
    text-align: center;
    .nav-item-a {
      color: #fff;
      display: block;
      font-size: 16px;
      font-size: var(--font-size-16);
      font-weight: 500;
      .title {
        transition: none;
        position: relative;
        z-index: 11;
      }
      &:hover,
      &.router-link-active {
        // transition: transform 0.2s;
        color: #fff;
        background-color: #248beb;
        // transform: skewX(-20deg);
        .title {
          // transform: skewX(20deg);
          transition: none;
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
